function playVideo(oembed, parent, target, mute) {
  if (oembed !== 'null' && oembed !== null) {
    const newTarget = target;
    let embedcode = oembed.html;
    const muteText = mute === 1 ? 'muted' : '';

    if (oembed.html.indexOf('iframe') > -1) {
      embedcode = embedcode.replace('mute=1', '');
      embedcode = embedcode.replace('controls=0', '');
      embedcode = embedcode.replace('showinfo=0', '');
      const regex = /<iframe.*?src="(.*?)"/;
      const oldSrc = regex.exec(embedcode)[1];
      const newSrc = `${oldSrc}&autoplay=1&showinfo=0&autohide=1&mute=${mute}`; // We need to set this ourselves, otherwise we are not sure it is gonna play.
      embedcode = embedcode.replace(oldSrc, newSrc);
    } else if (embedcode.indexOf('video') > -1) {
      embedcode = embedcode.replace('<video', `<video autoplay ${muteText}`);
    }

    parent.classList.add('video--hide-content');
    newTarget.innerHTML = embedcode;
  }
}

function isAutoplayElementInViewport(element) {
  const percentVisible = 40; // 40% of element visible. Can be changed if needed
  const rect = element.getBoundingClientRect();
  const windowHeight = (window.innerHeight || document.documentElement.clientHeight);

  return !(
    Math.floor(100 - (((rect.top >= 0 ? 0 : rect.top) / +-(rect.height)) * 100)) < percentVisible
      || Math.floor(100 - ((rect.bottom - windowHeight) / rect.height) * 100) < percentVisible
  );
}

document.addEventListener('DOMContentLoaded', () => {
  const videos = document.querySelectorAll('.js-video');

  if (videos && videos.length > 0) {
    for (let i = 0; i < videos.length; i += 1) {
      const currentVideo = videos[i];
      const playIcon = currentVideo.querySelector('.js-video-play-icon');
      const iframeWrapper = currentVideo.querySelector('.js-video-iframe-wrapper');
      const videoData = currentVideo.dataset.video;
      const oembed = JSON.parse(videoData).oEmbed;
      const autoPlay = currentVideo.dataset.autoplay.toLowerCase();
      let isPlaying = false;

      if (autoPlay === 'true') {
        document.addEventListener('scroll', () => {
          if (isAutoplayElementInViewport(currentVideo) && !isPlaying) {
            isPlaying = true;
            playVideo(oembed, currentVideo, iframeWrapper, 1);
          }
        });
      } else {
        currentVideo.addEventListener('click', (e) => {
          if (!isPlaying) {
            playVideo(oembed, e.currentTarget.parentNode, iframeWrapper, 0);
            isPlaying = true;
          }
        });
      }
    }
  }
});
